import {Injectable} from '@angular/core';
import {AuthActions} from "../auth/store/auth.models";

@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {
  private readonly dbName = 'coreaid';
  private readonly dbVersion = 1;
  private readonly storeName = 'authority';
  private db!: IDBDatabase;

  constructor() {
    this.openDatabase();
  }

  private openDatabase(): void {
    const request = indexedDB.open(this.dbName, this.dbVersion);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      this.db = (event.target as IDBOpenDBRequest).result;
      if (!this.db.objectStoreNames.contains(this.storeName)) {
        const store = this.db.createObjectStore('authority', {autoIncrement: true});
        store.createIndex('key', 'key', {unique: false});
      }
    };

    request.onsuccess = (event: Event) => {
      this.db = (event.target as IDBOpenDBRequest).result;
    };

    request.onerror = (event: Event) => {
      console.error('IndexedDB Hatası:', (event.target as IDBOpenDBRequest).error);
    };
  }

  async addBulkPermissions(storeName: string, dataArray: any) {
    if (this.db) {
      const transaction = this.db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      store.clear();
      if (dataArray.length > 0) {
        for(const item of dataArray){
           if (item.id != null) {
            this.addData(storeName, item);
          }
        }
      }
    }
  }


  async addData(storeName: string, data: AuthActions): Promise<number> {
    return new Promise((resolve, reject) => {
      if (this.db) {
        const transaction = this.db.transaction(storeName, 'readwrite');
        const store = transaction.objectStore(storeName);
        const request = store.add(data);

        request.onsuccess = () => {
          resolve(request.result as number);
        };

        request.onerror = () => {
            reject(request.error ?? new Error('Unknown request error'));
        };
      }
    });
  }


  getData(storeName: string, dataKey: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const index = store.index('key');
      const request = index.getAll(dataKey);

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
          reject(request.error ?? new Error('Unknown request error'));
      };
    });
  }

  updateData(storeName: string, data: object): Promise<void> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.put(data);

      request.onsuccess = () => resolve();
      request.onerror = () =>   reject(request.error ?? new Error('Unknown request error'));
    });
  }

  deleteData(storeName: string, dataId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.delete(dataId);

      request.onsuccess = () => resolve();
      request.onerror = () =>   reject(request.error ?? new Error('Unknown request error'));
    });
  }

  getAllData(storeName: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const request = store.getAll();

      request.onsuccess = () => resolve(request.result);
      request.onerror = () =>   reject(request.error ?? new Error('Unknown request error'));
    });
  }
}
